import snakecaseKeys from 'snakecase-keys'
import camelcaseKeys from 'camelcase-keys'
import axiosIns from '@/plugins/axios'

// 一日の成績(集計表単位)のレシート印刷。ルールエンジン店舗向け・SDP限定
export default {
  // ユーザーが所属する集計表の一覧(印刷対象の選択肢)+printable
  async getAggregations({ userId }) {
    const response = await axiosIns.get(
      '/admin/performance_reports/aggregations',
      { params: snakecaseKeys({ userId }) },
    )

    return camelcaseKeys(response.data, { deep: true })
  },

  // 指定集計表のスナップショット(伝票と同じ素材)
  async getPreview({ userId, targetDate, aggregationId }) {
    const response = await axiosIns.get(
      '/admin/performance_reports/preview',
      {
        params: snakecaseKeys({
          userId,
          targetDate,
          aggregationId,
        }),
      },
    )

    return camelcaseKeys(response.data, { deep: true })
  },

  // signature({ raster, width, height })は任意。あればサイン欄に画像として印字される
  print({
    userId, targetDate, aggregationId, signature = null,
  }) {
    return axiosIns.post(
      '/admin/performance_reports/print',
      snakecaseKeys({
        userId,
        targetDate,
        aggregationId,
        signature,
      }),
    )
  },
}
